import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionIcon, Flex, Pagination, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Add } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useDeleteSimpleEmailTemplateMutation, useGetSimpleEmailTemplatesQuery } from "../../graphql/graphql";
import { Confirmation } from "../../shared/Confirmation";
import { SimpleEmailTemplateModal } from "./SimpleEmailTemplateModal";
import { showErrorNotification, showSuccessNotification } from "../../shared/Notifications";
import { SimpleEmailTemplateRow } from "./SimpleEmailTemplateRow";
const SIMPLE_EMAIL_TEMPLATE_PAGE_SIZE = 100;
export const SimpleEmailTemplateView = ({ opened }) => {
    const [page, setPage] = useState(1);
    const [{ data }, refetchSimpleEmailTemplates] = useGetSimpleEmailTemplatesQuery({
        pause: !opened,
        requestPolicy: "cache-and-network",
        variables: {
            offset: (page - 1) * SIMPLE_EMAIL_TEMPLATE_PAGE_SIZE
        }
    });
    const [{ fetching: deleteFetching }, deleteSimpleEmailTemplate] = useDeleteSimpleEmailTemplateMutation();
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [modalOpened, { open: openModal, close: closeModal }] = useDisclosure(false);
    const [deleteOpened, { open: openDelete, close: closeDelete }] = useDisclosure(false);
    const templates = data?.simpleEmailTemplates?.simpleEmailTemplates ?? [];
    const totalCount = data?.simpleEmailTemplates?.totalCount ?? 0;
    const totalPages = useMemo(() => Math.max(Math.ceil(totalCount / SIMPLE_EMAIL_TEMPLATE_PAGE_SIZE), 1), [totalCount]);
    useEffect(() => {
        if (!opened) {
            setPage(1);
        }
    }, [opened]);
    useEffect(() => {
        if (page > totalPages) {
            setPage(totalPages);
        }
    }, [page, totalPages]);
    const handleClickEdit = (simpleEmailTemplate) => {
        setSelectedTemplate(simpleEmailTemplate ?? null);
        openModal();
    };
    const handleDelete = async () => {
        if (!selectedTemplate?.simpleEmailTemplateId)
            return;
        try {
            await deleteSimpleEmailTemplate({
                simpleEmailTemplateId: selectedTemplate.simpleEmailTemplateId
            });
            showSuccessNotification("Email template deleted.");
            refetchSimpleEmailTemplates();
            closeDelete();
            setSelectedTemplate(null);
        }
        catch (error) {
            console.error(error);
            showErrorNotification();
        }
    };
    return (_jsxs(Stack, { children: [_jsxs(Flex, { justify: "space-between", align: "center", style: { marginTop: "1rem", marginBottom: "1rem" }, children: [_jsx(Text, { variant: "body-strong", children: "Manage organization email templates" }), _jsx(ActionIcon, { variant: "filled", onClick: () => handleClickEdit(), children: _jsx(SvgIcon, { component: Add, fontSize: "inherit" }) })] }), _jsx(Stack, { gap: "0.2rem", children: templates.map((simpleEmailTemplate) => (_jsx(SimpleEmailTemplateRow, { simpleEmailTemplate: simpleEmailTemplate, onClickEdit: handleClickEdit, onClickDelete: (template) => {
                        setSelectedTemplate(template);
                        openDelete();
                    } }, simpleEmailTemplate?.simpleEmailTemplateId))) }), totalCount > SIMPLE_EMAIL_TEMPLATE_PAGE_SIZE ? (_jsxs(Flex, { justify: "space-between", align: "center", children: [_jsx("div", {}), _jsx(Pagination, { value: page, total: totalPages, onChange: setPage }), _jsx(Text, { variant: "body", style: { textAlign: "right", marginRight: "1rem" }, children: `Total: ${totalCount}` })] })) : null, _jsx(SimpleEmailTemplateModal, { opened: modalOpened, close: () => {
                    closeModal();
                    setSelectedTemplate(null);
                }, refetchSimpleEmailTemplates: refetchSimpleEmailTemplates, simpleEmailTemplateId: selectedTemplate?.simpleEmailTemplateId }), _jsx(Confirmation, { opened: deleteOpened, close: () => {
                    closeDelete();
                    setSelectedTemplate(null);
                }, action: "delete", additionalText: selectedTemplate
                    ? `Delete "${selectedTemplate.subject}"? Any referral stages using it will simply stop offering an email.`
                    : undefined, handleAction: handleDelete, isLoading: deleteFetching })] }));
};
